import React, { use, useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  InputLabel,
  FormHelperText,
  Container,
  Divider,
  Card,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useFormik } from "formik";
import { generateFileValidationSchema } from "../../../forms/addiitionaldocValidation";
import styles from "./AddiitionalDocuments.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useMutationByMethod } from "../../../services/hooks/useMutationByMethod";
import {
  configBlobToken,
  GetUrl,
  PatchUrl,
  PostUrl,
} from "../../../api/endpointConfig";
import { useLoader } from "../../../Loader/LoaderContext";
import { API_URL, API_VERSION, BLOB_API } from "../../../config/config";
import axios from "axios";
import placeholderImg from "../../../assets/images/nofile.jpg";
import { ToastService } from "../../../utils/toastService";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import {
  CustomDataTable,
  TableColumn,
} from "../../../components/CommnTable/CustomDataTable";
import { ApplicantForm, FilesInterface } from "../../../types/types";
import { useGet } from "../../../services/hooks/useGet";
import { getSecureBlobUrl } from "../../../utils/blobUploader";
import { Button as PrimeButton } from "primereact/button";
import { PdfPreview } from "../../../utils/PdfPreview";
import { formatDate } from "../../../utils/common";
type FormValues = {
  aadhaar: any;
  admissionReceipt: any;
  fees: any;
  electricity: any;
  studentPassbook: any;
  parentPassbook: any;
  incomeCertificate: any;
  principalLetter: any;
};
type selectRowInerfaec = {
  id: number;
  doc_name: string;
  doc_url: string;
};
const allowedExtensions = [".jpg", ".jpeg", ".png", ".pdf", ".doc", ".docx"];
const AddiitionalDocuments: React.FC = () => {
  const [mainData, setMainData] = useState<ApplicantForm[]>([]);
  const [selectedRow, setSelectedRow] = useState<selectRowInerfaec | null>(
    null
  );
  const [viewDocModalOpen, setViewDocModalOpen] = useState(false);
  const [existDocsShow, setExistDocsShow] = useState<boolean>(false);
  const { showLoader, hideLoader } = useLoader();
  const { id } = useParams();
  const navigate = useNavigate();
  const initialValues: FormValues = {
    aadhaar: null,
    admissionReceipt: null,
    fees: null,
    electricity: null,
    studentPassbook: null,
    parentPassbook: null,
    incomeCertificate: null,
    principalLetter: null,
  };

  const fields: {
    field: keyof FormValues;
    name: string;
    label: string;
    required: boolean;
    smallNote?: string;
  }[] = [
    {
      field: "aadhaar",
      name: "Aadhaar Card",
      label: "Student Aadhaar card",
      required: false,
    },
    {
      field: "admissionReceipt",
      name: "Admission Receipt",
      label: "Admission Receipt",
      required: false,
    },
    {
      field: "fees",
      name: "Fees",
      label:
        "Quarterly or annual fees structure of college / 1st / 2nd / 3rd year college",
      required: false,
      smallNote: "if any",
    },
    {
      field: "electricity",
      name: "Electricity Bill",
      label: "Electricity bill of last 6 months",
      required: false,
      smallNote: "Upload single file",
    },
    {
      field: "studentPassbook",
      name: "Student Passbook",
      label: "Student's bank passbook with 6 months transaction history",
      required: false,
      smallNote: "Upload single file",
    },
    {
      field: "parentPassbook",
      name: "Parent Passbook",
      label: "Parent's bank passbook with 6 months transaction history",
      required: false,
      smallNote: "Upload single file",
    },
    {
      field: "incomeCertificate",
      name: "Income Certificate",
      label: "Income certificate or Local Councillor Certificate",
      required: false,
    },
    {
      field: "principalLetter",
      name: "Principal Letter",
      label: "Letter from Principal",
      required: false,
    },
  ];
  const previewTemplate = (rowData: any) => {
    return (
      <Box onClick={() => setSelectedRow(rowData)}>
        {rowData?.doc_url?.includes(".pdf") ? (
          <>
            <img
              src={placeholderImg}
              alt="Document Preview"
              style={{
                width: "6rem",
                height: "auto",
                borderRadius: "4px",
                objectFit: "cover",
                boxShadow: "0 0 6px rgba(0,0,0,0.1)",
              }}
            />
          </>
        ) : (
          <>
            <img
              src={rowData.doc_url}
              alt="Document Preview"
              style={{
                width: "6rem",
                height: "auto",
                borderRadius: "4px",
                objectFit: "cover",
                boxShadow: "0 0 6px rgba(0,0,0,0.1)",
              }}
            />
          </>
        )}
      </Box>
    );
  };
  const actionTemplate = (rowData: any) => (
    <PrimeButton
      label="Download"
      icon="pi pi-download"
      className="p-button-success p-button-sm commonBtn"
      onClick={async () => {
        console.log("rowData", rowData);

        try {
          if (!rowData?.doc_name) {
            console.error("Invalid document name");
            return;
          }
          forceBlobDownload(rowData.doc_url, rowData.doc_name);
        } catch (error) {
          console.error("Download failed:", error);
        }
      }}
      type="button"
    />
  );
  const columns: TableColumn<FilesInterface>[] = [
    {
      field: "doc_url",
      header: "Preview",
      width: "10rem",
      filter: false,
      sortable: false,
      customBody: previewTemplate,
    },
    { field: "doc_name", header: "Document Name" },
    { field: "updatedDate", header: "Updated Date", width: "10rem" },
    {
      field: "doc_url",
      header: "Action",
      width: "10rem",
      filter: false,
      sortable: false,
      customBody: actionTemplate,
    },
  ];
  const forceBlobDownload = async (fileUrl: any, fileName: string) => {
    try {
      const response = await axios.get(fileUrl, {
        responseType: "blob",
      });
      const mimeType = response.data.type;
      const blob = new Blob([response.data], { type: mimeType });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(link.href);
    } catch (err) {
      console.error("Download failed", err);
    }
  };
  const validationSchema = React.useMemo(
    () => generateFileValidationSchema<FormValues>(fields),
    [fields]
  );
  const getFileNameFromUrl = (url: string): string => {
    const pathname = new URL(url).pathname; // "/documents/filename.jpg"
    return pathname.substring(pathname.lastIndexOf("/") + 1);
  };
  const [formError, setFormError] = useState<string | null>(null);

  const formik = useFormik({
    initialValues,
    validationSchema,
    validate: (values) => {
      // Ensure at least one file is uploaded
      const hasFile = Object.values(values).some((val) => val && val.blobFileUrl);
      if (!hasFile) {
        setFormError("Please upload at least one document.");
      } else {
        setFormError(null);
      }
      return {};
    },
    onSubmit: (values) => {
      // Prevent submit if no file uploaded
      const hasFile = Object.values(values).some((val) => val && val.blobFileUrl);
      if (!hasFile) {
        setFormError("Please upload at least one document.");
        return;
      }
      setFormError(null);
      formSubmit();
    },
  });

  const updateAdditionalDocuments = useMutationByMethod<any>(
    "post",
    `${PostUrl.postAdditionalDocuments}?application_id=${Number(id)}`
  );
  const patchAppCreateReq = async () => {
    const withDocUrl = Object.values(formik.values)
    .map((item, i) => ({
      doc_name: fields[i].name,
      doc_url:  item?.filename
    }))
    .filter(item => !!item.doc_url);
    showLoader();
    updateAdditionalDocuments.mutate(withDocUrl, {
      onSuccess: (data) => {
        console.log("data new===", data);
        hideLoader();
        ToastService.success(data);
        navigate(-1);
      },
      onError: (err) => {
        console.error("error", err);
        hideLoader();
      },
    });
  };
  const formSubmit = () => {
    patchAppCreateReq();
  };

  const handleMarksheetUploadChange = async (
    files: FileList | null,
    index: number
  ) => {
    if (!files || files.length === 0) return;

    const uploadedBlobUrls: any[] = [];

    for (const file of Array.from(files)) {
      try {
        const extension = file.name.split(".").pop()?.toLowerCase() || "pdf";

        const base64 = await new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const result = reader.result as string;
            resolve(result.split(",")[1]);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });

        const buffer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));

        const { data: sastokenInfo } = await axios.get(
          `${API_URL}/${API_VERSION}/${GetUrl.getSasToken}?file_type=${extension}`
        );

        const uploadUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${sastokenInfo.token}`;
        const putRes = await axios.put(uploadUrl, buffer, configBlobToken);

        if (![200, 201].includes(putRes.status)) {
          console.warn(`Upload failed for ${file.name}`);
          continue;
        }

        const { data: accessTokenInfo } = await axios.get(
          `${API_URL}/${API_VERSION}/${GetUrl.getSasTokenFile}?file_name=${sastokenInfo.filename}`
        );

        const secureBlobUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${accessTokenInfo.token}`;
        const blobFileUrl = `${BLOB_API}/documents/${sastokenInfo.filename}`;
        uploadedBlobUrls.push({
          blobFileUrl: blobFileUrl,
          secureBlobUrl: secureBlobUrl,
          filename: sastokenInfo.filename,
          fileType: file.type,
          docName: file.name,
        });
      } catch (err) {
        console.error("Upload failed:", err);
      }
    }

    // Step 3: Push to Formik – store the uploaded URL in the correct field
    const fieldNames = Object.keys(formik.values) as (keyof FormValues)[];
    const targetField = fieldNames[index];

    if (targetField) {
      formik.setFieldValue(
        targetField,
        uploadedBlobUrls.length > 0 ? uploadedBlobUrls[0] : null
      );
    }
  };

  const getApplicationData = useGet<any>(
    id ? `${GetUrl.getApplication}?application_id=${id}` : "",
    {},
    !!id
  );
  const fetchApplicationData = async () => {
    showLoader();
    try {
      const result = await getApplicationData.refetch();
      if (result.data) {
        const updatedDocs = await secureAllDocuments(
          result?.data.additional_documents
        );

        // const filteredDocuments = updatedDocs.filter((item) => {
        //   const lowerCaseName = item.doc_url.toLowerCase();
        //   return hasValidExtensionInUrl(lowerCaseName) && item;
        // });
        setMainData([
          { ...result.data, additional_documents: updatedDocs },
        ]);
        hideLoader();
      }
    } catch (error) {
      console.error("Error fetching app version:", error);
      hideLoader();
    }
  };
  const hasValidExtensionInUrl = (url: string): boolean => {
    try {
      const cleanPath = new URL(url).pathname;
      const fileName = cleanPath.split("/").pop() || "";
      const dotIndex = fileName.lastIndexOf(".");
      const ext = dotIndex !== -1 ? fileName.slice(dotIndex).toLowerCase() : "";
      return allowedExtensions.includes(ext);
    } catch (e) {
      console.error("Invalid URL:", url);
      return false;
    }
  };
  const secureAllDocuments = async (documents: any[]) => {
    const securedDocs = await Promise.all(
      documents.map(async (doc) => {
        try {
          const secureUrl = await getSecureBlobUrl({
            fileName: extractFileName(doc.doc_url) as any,
            blobBaseUrl: BLOB_API,
            getTokenUrl: `${API_URL}/${API_VERSION}/${GetUrl.getSasTokenFile}`,
          });

          return {
            ...doc,
            doc_url: secureUrl,
          };
        } catch (error) {
          console.error(`Error securing URL for ${doc.doc_name}`, error);
          return doc; // fallback to original if failed
        }
      })
    );

    return securedDocs;
  };
  const extractFileName = (url: string): string | null => {
    try {
      const pathname = new URL(url).pathname;
      return pathname.split("/").pop() || null;
    } catch (err) {
      // Fallback: try splitting as a regular string (non-URL)
      const parts = url.split("/");
      return parts.length ? parts[parts.length - 1] : null;
    }
  };
  useEffect(() => {
    if (id) {
      fetchApplicationData();
    }
  }, [id]);
  const handleSuccessModalClose = () => {
    setViewDocModalOpen(false);
  };
  useEffect(() => {
    if (selectedRow) {
      setViewDocModalOpen(true);
    }
  }, [selectedRow]);
  return (
    <>
      <Container className={styles.container}>
        <Box className={styles.header}>
          <Typography variant="h5" className={styles.title}>
            Scholarship Application Form
          </Typography>
          {/* <Box className={styles.navigationButtons}>
            <Button
              variant="contained"
              className={styles.saveButton}
              onClick={() => formik.handleSubmit()} // This will submit the current step's data
            >
              Submit
            </Button>
          </Box> */}
        </Box>

        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          paddingBottom={2}
        >
          <Box p={0} display={"flex"} alignItems={"center"}>
            <Typography>Application ID: </Typography>
            <Typography fontWeight={"bold"}>{id}</Typography>
          </Box>
          <Box p={0} display={"flex"} alignItems={"center"}>
            <Typography>Application Date: </Typography>
            <Typography fontWeight={"bold"}>{formatDate(mainData[0]?.created_at)}</Typography>
          </Box>
          <Box p={0} display={"flex"} alignItems={"center"}>
            <Typography>Applicant Name: </Typography>
            <Typography fontWeight={"bold"}>{mainData[0]?.personal_info?.first_name} {mainData[0]?.personal_info?.last_name}</Typography>
          </Box>
          <Box p={0} display={"flex"} alignItems={"center"}>
            <Typography>Applicant Phone: </Typography>
            <Typography fontWeight={"bold"}>{mainData[0]?.personal_info?.phone}</Typography>
          </Box>
          <Box p={0} display={"flex"} alignItems={"center"}>
            <Typography>Applicant Email: </Typography>
            <Typography fontWeight={"bold"}>{mainData[0]?.personal_info?.email}</Typography>
          </Box>
        </Box>
        <form onSubmit={formik.handleSubmit} className={"form-group formPanel"}>
           
          {formError && (
            <Box mb={2}>
              <FormHelperText error style={{ textAlign: "center" }}>
                {formError}
              </FormHelperText>
            </Box>
          )}
          <Box mb={2}>
            <Typography variant="subtitle1" align="center" gutterBottom>
              Documents Upload
            </Typography>
            <Typography variant="body2" align="center" color="textSecondary">
              Please upload the required documents in PDF or image format. Note:
              All documents should be clear and legible.
            </Typography>
          </Box>
 
          <Box className={styles.fieldRow}>
            {fields?.map((field, index) => (
              <Box className={styles.fileUploadField} key={index}>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 0 }}
                  paddingBottom={"0.25rem"}
                  className={styles.labelText}
                >
                  {field.label}{" "}
                  {field.smallNote && (
                    <span className={styles.smallNote}>
                      ({field.smallNote})
                    </span>
                  )}
                </Typography>
                <Box>
                  <Box
                    className={styles.fileUploadBox}
                    display="flex"
                    alignItems="center"
                  >
                    <Button
                      variant="contained"
                      component="label"
                      className="commonBtn"
                      sx={{ flex: "none", marginRight: "1rem" }}
                      startIcon={<UploadFileIcon />}
                    >
                      Choose File
                      <input
                        type="file"
                        hidden
                        accept="application/pdf,image/*"
                        onChange={(event) => {
                          handleMarksheetUploadChange(
                            event.target.files,
                            index
                          );
                        }}
                      />
                    </Button>
                    <Typography variant="body2" sx={{ marginRight: 1 }}>
                      {formik.values[field.field]?.docName || "No file chosen"}
                    </Typography>
                    {formik.values[field.field] && (
                      <Button
                        size="small"
                        color="error"
                        className={"closeButton"}
                        onClick={() => formik.setFieldValue(field.field, null)}
                      >
                        &#10006;
                      </Button>
                    )}
                  </Box>
                  {formik.touched[field.field] &&
                    formik.errors[field.field] && (
                      <FormHelperText error>
                        {formik.errors[field.field] as any}
                        {field.name}
                      </FormHelperText>
                    )}

                  {/* File preview */}
                  {formik.values[field.field] instanceof File && (
                    <Box mt={1}>
                      {["image/jpeg", "image/png"].includes(
                        (formik.values[field.field] as File).type
                      ) ? (
                        <img
                          src={URL.createObjectURL(
                            formik.values[field.field] as File
                          )}
                          alt="Preview"
                          style={{
                            maxWidth: 120,
                            maxHeight: 120,
                            borderRadius: 4,
                          }}
                          onLoad={(e) =>
                            URL.revokeObjectURL(
                              (e.target as HTMLImageElement).src
                            )
                          }
                        />
                      ) : (formik.values[field.field] as File).type ===
                        "application/pdf" ? (
                        <a
                          href={URL.createObjectURL(
                            formik.values[field.field] as File
                          )}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            setTimeout(() => {
                              URL.revokeObjectURL(
                                URL.createObjectURL(
                                  formik.values[field.field] as File
                                )
                              );
                            }, 1000);
                          }}
                        >
                          Preview PDF
                        </a>
                      ) : null}
                    </Box>
                  )}
                  {formik.values[field.field]?.fileType ===
                  "application/pdf" ? (
                    <Box mt={1} style={{
                            minHeight: 150,
                            borderRadius: 8,
                          }}>{formik.values[field.field]?.docName}</Box>
                  ) : (
                    <>
                      <Box mt={1}>
                        <img
                          src={
                            typeof formik.values[field.field]?.secureBlobUrl ===
                            "string"
                              ? formik.values[field.field]?.secureBlobUrl
                              : formik.values[field.field]?.secureBlobUrl
                              ? URL.createObjectURL(
                                  formik.values[field.field]?.secureBlobUrl
                                )
                              : placeholderImg
                          }
                          alt="Preview"
                          style={{
                            maxHeight: 150,
                            borderRadius: 8,
                          }}
                        />
                      </Box>
                    </>
                  )}
                </Box>
              </Box>
            ))}
          </Box>
          
          
          <Box mt={2} display="flex" justifyContent="center" gap={2}>
            <Button
              variant="contained"
              color="info"
              onClick={() => window.history.back()}
              className={styles.backButton}
            >
              Back
            </Button>
            <Button
              variant="contained"
              className={styles.saveButton}
              type="submit"
            >
              Upload
            </Button>
          </Box>
        </form>
        <Divider style={{marginTop: '1rem', marginBottom: '1rem'}} />
        <Box display={'flex'} justifyContent={'center'}>
            <Box mb={2} p={2} bgcolor="#f1f5f9" borderRadius={2} display={'inline-flex'} alignItems={'center'} justifyContent={'center'} gap={'1rem'}>
              <Typography variant="subtitle2" gutterBottom>
                Already uploaded documents
              </Typography>
              <Button variant="contained" color="success" onClick={()=>setExistDocsShow(!existDocsShow)} style={{cursor:'pointer'}}>
                Click here to view
              </Button>
            </Box>
          </Box>
          <Box display={'flex'} justifyContent={'center'}>
            <Typography
              variant="caption"
              color="textSecondary"
              display="block"
              gutterBottom
            >
              Note: Please ensure all uploaded documents do not exceed the maximum
              file size limit of 1 MB per document.
            </Typography>
          </Box>
        {existDocsShow && (<>
        <Card
          style={{
            padding: "1rem 0.5rem",
            border: 0,
            boxShadow: "none",
            background: "none",
          }}
        >
          {mainData.length > 0 && (
          <Box className={"cardBoxUI cardBoxInnerUI"}>
            <CustomDataTable<FilesInterface>
              data={mainData[0]?.additional_documents}
              columns={columns}
              tableTitle="Application Review"
              rowsPerPage={10}
              globalFilterEnabled={false}
              exportExcelShow={true}
            />
          </Box>
          )}
        </Card>
        <Dialog
          open={viewDocModalOpen}
          onClose={handleSuccessModalClose}
          PaperProps={{
            sx: {
              width: 700,
              maxWidth: "90%",
            },
          }}
        >
          <DialogTitle>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="h6" color="success.main">
                {selectedRow && selectedRow?.doc_name}
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent>
            {selectedRow?.doc_url?.includes(".pdf") ? (
              <PdfPreview url={selectedRow?.doc_url} />
            ) : (
              <img
                src={selectedRow?.doc_url}
                alt="Document Preview"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "4px",
                  objectFit: "cover",
                  boxShadow: "0 0 6px rgba(0,0,0,0.1)",
                }}
              />
            )}
          </DialogContent>
          <DialogActions
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "1rem",
            }}
          >
            <Button
              onClick={handleSuccessModalClose}
              variant="contained"
              className={styles.commonButton}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        </>)}
         
      </Container>
    </>
  );
};
export default AddiitionalDocuments;
